/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sunny_Loose_Stingray_BubbleInputs */

const fr_sunny_loose_stingray_bubble = /** @type {(inputs: Sunny_Loose_Stingray_BubbleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les notifications te permettent de recevoir des rappels sur les séances et un suivi personnalisé sur d'autres fonctionnalités a venir.`)
};

/**

* @param {Sunny_Loose_Stingray_BubbleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const sunny_loose_stingray_bubble = /** @type {((inputs?: Sunny_Loose_Stingray_BubbleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sunny_Loose_Stingray_BubbleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_sunny_loose_stingray_bubble(inputs)
});